// 接口列表
import http from '@/plugins/wjtools'

// 获取图片验证码
export const getImgCode = (params) => http.get('cts-auth-server/auth/user/img-code', null)

// 发送手机验证码
export const sendPhoneCode = (phone, imgId, imgCode) => http.get('cts-auth-server/auth/user/send-phone-code?phone=' + phone + '&imgId=' + imgId + '&imgCode=' + imgCode)

// 手机验证码登录
export const login = (params) => http.post('cts-auth-server/auth/user/sms-login-in', params)

// 获取企微二维码
export const qwQrCode = (params) => http.get('/cts-auth-server/auth/qw/login/qr-code', params)

// 校验企微登录状态
export const checkLoginStatus = (params) => http.get('/cts-auth-server/auth/qw/login/by-state?state=' + params)

// 企微登录
export const qwLogin = (code, state) => http.get('/cts-auth-server/auth/qw/login//by-code?code=' + code + '&state=' + state)

// 发送邮箱验证码
export const sendEmailCode = (email, imgId, imgCode) => http.get('cts-auth-server/auth/user/send-email-code?email=' + email + '&imgId=' + imgId + '&imgCode=' + imgCode)

// 邮箱验证码登录
export const emailLogin = (params) => http.post('cts-auth-server/auth/user/email-login-in', params)

// 退出系统
export const loginOut = (params) => http.post('cts-auth-server/auth/user/login-out', params)

// 获取当前用户信息
export const getUserInfo = (params) => http.get('cts-auth-server/auth/user/info', null)

// 获取当前用户系统的列表
export const getSystemList = (params) => http.get('cts-auth-server/auth/user/sys-list', null)

// 点击去绑定,返回跳转连接
export const bindSystem = (params) => http.get('/cts-auth-server/auth/user/system-redirect?systemCode=' + params)

// 解除绑定用户和系统
export const unbindUser = (params) => http.post('cts-auth-server/auth/user/unbind', params)
